import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import btcSrc from "../assets/btc.png";
import { motion } from "framer-motion";

const Home = () => {
  const textVariants = {
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 2, ease: "easeOut" },
    },
    hidden: { opacity: 0, y: 10 },
  };

  const keywordVariants = {
    visible: {
      opacity: 1,
      x: 0,
      color: "#38B2AC",
      transition: {
        duration: 2,
        ease: "easeInOut",
        repeat: Infinity,
        repeatType: "reverse",
      },
    },
    hidden: {
      opacity: 1,
      x: -20,
      color: "#F6E05E",
    },
  };

  return (
    <Box
      w="full"
      h="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      bgColor="blackAlpha.900"
    >
      <motion.div
        style={{
          height: "60%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
        drag
        dragConstraints={{
          right: 10,
          left: 10,
          top: 1,
          bottom: 1,
        }}
        whileHover={{ scale: 1.1 }}
        transition={{ duration: 0.3 }}
        whileTap={{ scale: 0.9 }}
      >
        <Image
          maxW="80%"
          maxH="80%"
          objectFit="contain"
          src={btcSrc}
          alt="Bitcoin Logo"
        />
      </motion.div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={textVariants}
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Text
          fontSize={{ base: "2xl", md: "3xl", lg: "4xl" }}
          textAlign="center"
          textTransform="uppercase"
          fontWeight="semibold"
          color="whiteAlpha.900"
          mt={8}
        >
          Welcome to <motion.span variants={keywordVariants}>Nobto</motion.span>
        </Text>
        <Text
          fontSize={{ base: "lg", md: "xl", lg: "2xl" }}
          textAlign="center"
          color="whiteAlpha.800"
          mt={4}
        >
          Explore the{" "}
          <motion.span variants={keywordVariants}>exciting world</motion.span>{" "}
          of{" "}
          <motion.span variants={keywordVariants}>cryptocurrencies</motion.span>{" "}
          and{" "}
          <motion.span variants={keywordVariants}>
            blockchain technology
          </motion.span>
          .
        </Text>
      </motion.div>
    </Box>
  );
};

export default Home;
